export function getGeneralisedEntityByMode(mode = '') {
    const [generalisedEntity] = mode.split('_');

    if (generalisedEntity === 'EA') return 'agency';
    if (generalisedEntity === 'CONV') return 'conveyancing';
    return 'mortgage';
}
